import apiClient from "../common/apiClient.js";

export default class ContentController {
  async CreateData(data, token) {
    try {
      return await apiClient.post("/contentManage", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async UpdateData(data, token) {
    try {
      return await apiClient.put("/contentManage", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async UploadImages(data, token) {
    try {
      return await apiClient.post("/imagesManage", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }

  async GetSectionMaster() {
    try {
      return await apiClient.get("/masters/section");
    } catch (error) {
      return error;
    }
  }
  async getMasterSubSection(id) {
    try {
      return await apiClient.get("/masters/subSection/" + id);
    } catch (error) {
      return error;
    }
  }
  async GetGridData(tenantId, token) {
    try {
      return await apiClient.get("/tenant/getSections/" + tenantId, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
  async GetContentId(id, token) {
    try {
      return await apiClient.get("/tenant/content/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
  async Delete(id, token) {
    try {
      return await apiClient.delete("/tenant/content/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
  async DeleteImagebyId(data, token) {
    try {
      return await apiClient.post("/deleteContentImage", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
}
